import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import { userIdentityShape, childrenShape, catalogBibShape } from '@bibliocommons/bc-prop-types';

import TextUgcDisplay from './TextUgcDisplay';

export default function TextUgcContainer(props) {
  const intl = useIntl();
  const { likesCount } = props;
  const likesButtonText = intl.formatMessage({ id: 'existing_likes' }, { count: likesCount });

  return <TextUgcDisplay {...props} intl={intl} likesButtonText={likesButtonText} />;
}

TextUgcContainer.propTypes = {
  ugcType: PropTypes.string,
  catalogBib: catalogBibShape.isRequired,
  author: userIdentityShape,
  displayStaffBadge: PropTypes.bool,
  compact: PropTypes.bool,
  createdDate: PropTypes.string,
  rating: PropTypes.number,
  likesCount: PropTypes.number,
  isLikedByCurrentUser: PropTypes.bool,
  id: PropTypes.number,
  children: childrenShape,
  optionsDropdownRef: PropTypes.object,
  className: PropTypes.string,
  handleDelete: PropTypes.func,
  handleEdit: PropTypes.func,
  handleLike: PropTypes.func,
  handleUnlike: PropTypes.func,
  hidePermalink: PropTypes.bool
};
